import cn from "classnames"
import { Formik } from "formik"
import { find as _find } from "lodash"
import React, { Component } from 'react'
import PageContents from '../components/pageContents'
import SEO from "../components/seo"
import NewLayout from '../layout/newLayout'
import { sendContact } from "../services/contact"
import { signUp } from "../services/email"
import styles from '../styles/scss/pages/contactUs.module.scss'
import {
	TextInput,
	Textarea,
	Select,
	Checkbox,
	Fieldset,
	Disclosure,
	ErrorSummary,
	FormStatus,
	SubmitButton,
	RequiredNote,
	bind,
	summaryErrors,
	intlPhoneError,
	formatPhone,
	INTL_PHONE_HELP,
	isValidEmail,
	fieldError,
	formStyles as f,
} from '../components/form'

// Fields that only appear for some topics, with their empty values. Answers
// left in them after switching topic are blanked before sending, so a UPC or
// region from an earlier topic doesn't reach the notification email.
const PRODUCT_FIELDS = { brand: null, product: null, upc: "", lotCode: "" }
const REGION_FIELDS = { region: null }
const OFFER_ONLY_FIELDS = { jobTitle: "", industry: "", numberOfEmployees: "", yearlyUsage: "", biggestConcern: "" }
const STANDARD_ONLY_FIELDS = { addr2: "", city: "", state: "", country: "", fax: "", age: "", gender: "" }

export default class Index extends Component {

	state = {
		showExtra: false,
		submitted: false,
		submitError: false,
		selectedTopic: null,
		selectedBrand: null,
		selectedProduct: null,
		selectedRegion: null,
		selectedAge: null,
		selectedNumberOfEmployees: null,
		selectedIndustry: null,
	};

	topics = [{
		value: 'product-compliment',
		text: 'Compliment of Product',
		collectProductInfo: true,
		collectRegion: false,
		allowSubmit: true
	}, {
		value: 'product-question',
		text: 'Question about Product',
		collectProductInfo: true,
		collectRegion: false,
		allowSubmit: true
	}, {
		value: 'product-problem',
		text: 'Problem with Product',
		collectProductInfo: true,
		collectRegion: false,
		allowSubmit: true
	}, {
		value: 'product-request',
		text: 'Product Request',
		collectProductInfo: false,
		collectRegion: false,
		allowSubmit: false
	}, {
		value: 'media',
		text: 'Media Opportunity/Partnership',
		collectProductInfo: false,
		collectRegion: false,
		allowSubmit: true
	}, {
		value: 'investor',
		text: 'Investor Relations',
		collectProductInfo: false,
		collectRegion: false,
		allowSubmit: true
	}, {
		value: 'distributor',
		text: 'Becoming a Distributor',
		collectProductInfo: false,
		collectRegion: true,
		allowSubmit: true
	}, {
		value: 'sponsorship',
		text: 'Sponsorship',
		collectProductInfo: false,
		collectRegion: false,
		allowSubmit: false
	}, {
		value: 'charity',
		text: 'Charitable Donation',
		collectProductInfo: false,
		collectRegion: false,
		allowSubmit: false
	}, {
		value: 'website',
		text: 'Web Site',
		collectProductInfo: false,
		collectRegion: false,
		allowSubmit: true
	}, {
		value: 'sticker',
		text: 'Sticker Request',
		collectProductInfo: false,
		collectRegion: false,
		allowSubmit: false
	},{
		value: 'offer',
		text: 'Facility/Site Assessment Offer',
		collectProductInfo: false,
		collectRegion: false,
		allowSubmit: true
	}]

	brands = [{
		value: 'wd-40',
		text: 'WD-40',
		products: [
			"1-Gallon",
			"3 oz Handy Can",
			"8 oz Smart Straw",
			"11 oz Smart Straw",
			"12 oz Smart Straw",
			"14.4 oz EZ-REACH",
			"18 oz Big Blast Can",
			"No-Mess Pen",
			"No-Mess Pen with Custom Imprint",
			"20 oz Trigger Pro Non-Aerosol",
			"16 oz Industrial Size",
			"Specialist Carb/Throttle Body & Parts Cleaner",
			"Specialist Spray & Stay Gel Lubricant",
			"Specialist Rust Release Penetrant Spray",
			"Specialist Water Resistant Silicone Lubricant",
			"Specialist Protective White Lithium Grease",
			"Specialist Long-Term Corrosion Inhibitor",
			"Specialist Rust Remover Soak",
			"Specialist Dirt & Dust Resistant Dry Lube",
			"Specialist Machine & Engine Degreaser",
			"Specialist Industrial-Strength Degreaser",
			"Specialist Industrial-Strength Cleaner & Degreaser",
			"Specialist Electrical Contact Cleaner Spray",
			"Specialist Superior Performance True Multi-Purpose Grease",
			"Specialist Heavy-Duty High Temperature Grease",
			"Specialist Heavy-Duty Extreme Pressure Grease",
			"Specialist Marine Grade Water Resistant Grease",
			"Other"
		]
	}, {
		value: '3-in-one',
		text: '3-IN-ONE',
		products: [
			"RVcare Slide-Out Silicone Lube",
			"RVcare Window & Track Dry Lube",
			"Multi-Purpose Drip Oil",
			"Multi-Purpose Telescoping Spout",
			"Motor Oil",
			"Garage Door Lube",
			"Fast-Acting Penetrant",
			"All-Temp Silicone",
			"Dry Lube",
			"Pneumatic Tool Oil",
			"PTFE Lube",
			"Other"
		]
	}, {
		value: 'lava',
		text: 'Lava',
		products: [
			"Lava Bar",
			"Lava Bar Twin-Pack",
			"Lava Liquid",
			"Other"
		]
	}, {
		value: 'x-14',
		text: 'X-14',
		products: [
			"Automatic Toilet Bowl Cleaner - Bleach",
			"Automatic Toilet Bowl Cleaner - Blue plus Fragrance",
			"Mildew Stain Remover",
			"Other"
		]
	}, {
		value: '2000-flushes',
		text: '2000 Flushes',
		products: [
			"Bleach",
			"Blue Plus Bleach",
			"Blue Plus Detergents",
			"Other"
		]
	}, {
		value: 'carpet-fresh',
		text: 'Carpet Fresh',
		products: [
			"Powder Family",
			"Quick-Dry Foam Family",
			"Other"
		]
	}, {
		value: 'spot-shot',
		text: 'Spot Shot',
		products: [
			"14 oz. Aerosol",
			"14 oz. Pet Aerosol",
			"18 oz. Professional Aerosol",
			"22 oz. Pet Trigger",
			"22 oz. Trigger",
			"Other"
		]
	}, {
		value: 'wd-40-bike',
		text: 'WD-40 Bike',
		products: [
			"All-Purpose Bike Wash",
			"Chain Cleaner & Degreaser",
			"All-Conditions Chain Lube",
			"Dry Chain Lubricant",
			"Wet Chain Lubricant"
		]
	}, {
		value: 'wd-40-motorcycle',
		text: 'WD-40 Motorcycle',
		products: [
			"Total Wash 33 8 Oz",
			"Chain Cleaner 18 Oz",
			"Chain Lube 14 Oz",
			"Chain Wax 13 5 Oz",
			"Total Shine 12 Oz"
		]
	}]

	regions = [{
		value: 'us',
		text: 'US'
	}, {
		value: 'canada',
		text: 'Canada'
	}, {
		value: 'latin-america',
		text: 'Latin America'
	}, {
		value: 'europe-middleeast-africa',
		text: 'Europe/Middle East/Africa'
	}, {
		value: 'asiapacific-australia',
		text: 'Asia Pacific/Australia'
	}, {
		value: 'china',
		text: 'China'
	}]

	ages = [{
		value: 'Under 15',
		text: 'Under 15'
	}, {
		value: '15 to 17',
		text: '15 to 17'
	}, {
		value: '18 to 24',
		text: '18 to 24'
	}, {
		value: '25 to 34',
		text: '25 to 34'
	}, {
		value: '35 to 44',
		text: '35 to 44'
	}, {
		value: '45 to 54',
		text: '45 to 54'
	}, {
		value: '55 to 64',
		text: '55 to 64'
	}, {
		value: '65 or Older',
		text: '65 or Older'
	}]

	industries = [{
		value: 'food-beverage',
		text: 'Food & Beverage'
	}, {
		value: 'oil-gas-chemical',
		text: 'Oil / Gas / Chemical'
	}, {
		value: 'mining-aggregate',
		text: 'Mining / Aggregate'
	}, {
		value: 'forest-paper',
		text: 'Forest / Paper'
	}, {
		value: 'power-utilities',
		text: 'Power & Utilities'
	}, {
		value: 'pharmaceutical',
		text: 'Pharmaceutical'
	}, {
		value: 'government',
		text: 'Government'
	}, {
		value: 'transportation-vehicles',
		text: 'Transportation / Vehicles'
	}, {
		value: 'warehouse-logistics',
		text: 'Warehouse & Logistics'
	}, {
		value: 'metal-metal-fabrication',
		text: 'Metal / Metal Fabrication'
	}, {
		value: 'commercial-construction',
		text: 'Commercial/Construction'
	}, {
		value: 'other',
		text: 'OTHER'
	}]

	numberOfEmployees = [{
		value: '1 to 9',
		text: '1 to 9'
	}, {
		value: '10 to 49',
		text: '10 to 49'
	}, {
		value: '50 to 99',
		text: '50 to 99'
	}, {
		value: '100 to 499',
		text: '100 to 499'
	}, {
		value: 'Over 500',
		text: '500+'
	}]

	genders = [{
		value: 'Male',
		text: 'Male'
	}, {
		value: 'Female',
		text: 'Female'
	}]

	handleClickExtraInfo = () => {
		this.setState({
			showExtra: !this.state.showExtra
		})
	}

	getIsAssessmentOffer = () => {
		const { location } = this.props;
		const urlParams = new URLSearchParams(location.search);
		return urlParams.get("assessment_offer") === "true";
	}

	renderTopicPlaceholder = () => {
		const isAssessmentOffer = this.getIsAssessmentOffer();

		if(isAssessmentOffer) {
			return _find(this.topics, { value: "offer" }).text
		}

		return 'Select a topic'
	}

	componentDidMount() {
		const isAssessmentOffer = this.getIsAssessmentOffer();

		if(isAssessmentOffer) {
			this.setState({
				selectedTopic: _find(this.topics, { value: "offer" })
			})
		}
	}

	// Topic-dependent rules live here so validate() and render() agree
	topicRules = () => {
		const topic = this.state.selectedTopic
		return {
			isOffer: !!topic && topic.value === 'offer',
			collectProductInfo: !!topic && topic.collectProductInfo,
			collectRegion: !!topic && topic.collectRegion,
			// Some topics only show a notice; the form can't be submitted for them
			allowSubmit: !topic || topic.allowSubmit,
		}
	}

	validate = values => {
		const { isOffer, collectProductInfo, collectRegion } = this.topicRules()
		const errors = []
		if (values.topic === null) {
			errors.push({ field: "topic", message: "Please select a topic" })
		}
		if (collectProductInfo && values.brand === null) {
			errors.push({ field: "brand", message: "Please select a brand" })
		}
		if (collectProductInfo && values.brand !== null && values.product === null) {
			errors.push({ field: "product", message: "Please select a product" })
		}
		if (collectRegion && values.region === null) {
			errors.push({ field: "region", message: "Please select a region" })
		}
		if (values.firstName === "") {
			errors.push({ field: "firstName", message: "First Name is required" })
		}
		if (values.lastName === "") {
			errors.push({ field: "lastName", message: "Last Name is required" })
		}
		if (values.email === "") {
			errors.push({ field: "email", message: "Email is required" })
		} else if (!isValidEmail(values.email)) {
			errors.push({ field: "email", message: "Invalid email address" })
		}
		// Required on the standard layout; optional on the site assessment offer
		// International numbers accepted (this form also takes a Country)
		const phoneMsg = intlPhoneError(values.phone, { required: !isOffer, requiredMessage: "Mobile Phone Number is required" })
		if (phoneMsg) errors.push({ field: "phone", message: phoneMsg })
		if (collectProductInfo && values.brand !== null && values.product !== null && values.upc === "") {
			errors.push({ field: "upc", message: "Please enter the 12 digit UPC" })
		}
		if (!isOffer && (values.message === null || values.message === "")) {
			errors.push({ field: "message", message: "Please enter a comment, question or request" })
		}
		// Additional information (standard layout only)
		if (!isOffer) {
			const faxMsg = intlPhoneError(values.fax, { label: "Fax number" })
			if (faxMsg) errors.push({ field: "fax", message: faxMsg })
		}
		return errors
	}

	// Same keys as the form state, minus answers to fields the chosen topic
	// doesn't show
	payload = values => {
		const { isOffer, collectProductInfo, collectRegion } = this.topicRules()
		return {
			...values,
			phone: formatPhone(values.phone),
			fax: formatPhone(values.fax),
			...(collectProductInfo ? {} : PRODUCT_FIELDS),
			...(collectRegion ? {} : REGION_FIELDS),
			...(isOffer ? STANDARD_ONLY_FIELDS : OFFER_ONLY_FIELDS),
		}
	}

	onSubmit = (values, { setSubmitting }) => {
		this.setState({ submitError: false })
		const fail = err => {
			console.log('ERROR!')
			console.log(err)
			setSubmitting(false)
			this.setState({ submitError: true })
		}
		const done = () => {
			setSubmitting(false)
			this.setState({ submitted: true })
		}
		sendContact(this.payload(values)).then(() => {
			if (values.lists.length > 0) {
				return signUp({
					firstName: values.firstName,
					lastName: values.lastName,
					email: values.email,
					phone: formatPhone(values.phone),
					lists: values.lists,
					industry: '',
					industrytime: '',
					birthday: '',
					userplus18yearsold: (values.age !== '15 to 17' && values.age !== 'Under 15') ? true : false,
					confirmation: true,
					optSubject: '',
					optMessage: '',
					signupFormID: 1828532,
					formIdentifier: 'contact'
				}).then(done, err => {
					// The contact request already went through; a failed newsletter
					// signup must not invite a duplicate resubmission
					console.log(err)
					done()
				})
			}
			done()
		}).catch(fail)
	}

	onTopicChange = (props, e) => {
		const value = e.target.value
		this.setState({
			selectedTopic: _find(this.topics, { value }),
			selectedBrand: null,
			selectedProduct: null,
			selectedRegion: null
		}, () => {
			props.setFieldValue('topic', value)
			props.setFieldValue('brand', null)
			props.setFieldValue('product', null)
		})
	}

	onBrandChange = (props, e) => {
		const value = e.target.value
		this.setState({
			selectedBrand: _find(this.brands, { value }),
			selectedProduct: null
		}, () => {
			props.setFieldValue('brand', value)
			props.setFieldValue('product', null)
		})
	}

	onRegionChange = (props, e) => {
		const value = e.target.value
		this.setState({
			selectedRegion: _find(this.regions, { value })
		}, () => {
			props.setFieldValue('region', value)
		})
		if (value === 'us') {
			window.open(
				'https://wd40.my.site.com/distributorsurvey/s/',
				'_blank'
			);
			window.location.href = '/confirm/';
		}
		if (this.state.selectedTopic.value === 'distributor' && value === 'canada') {
			window.open(
				'https://wd40.my.site.com/distributorsurveyca/s/',
				'_blank'
			);
		}
	}

	toggleList = (props, id, checked) => {
		const lists = props.values.lists.filter(l => l !== id)
		props.setFieldValue('lists', checked ? [...lists, id] : lists)
	}

	render() {
		const { showExtra, selectedTopic, selectedBrand, submitError } = this.state
		const pg = this.props.pageContext.page
		const attached = pg.attachments.filter((att) => {
			return att.slug === 'thank-you-contact'
		})
		var thankyou = null
		if (attached.length > 0) {
			thankyou = attached[0]
		} else {
			throw new Error("thank-you-contact is not attached")
		}
		const { isOffer, collectProductInfo, collectRegion, allowSubmit } = this.topicRules()
		return (
			<NewLayout>
				{pg.seo.title && <h1 style={{ display: 'none' }}>{pg.seo.title}</h1>}
				<SEO page={pg} />
				<div className='d-flex flex-column flex-fill'>
					<div className={styles.container}>
						<div className={cn(styles.formItems, "row")}>
							<div className={styles.formContainer}>
								{
									this.state.submitted ?
										<PageContents content={thankyou.content} />
										:
										<>
											<PageContents content={pg.content} />
											<Formik
												initialValues={{
													firstName: "",
													lastName: "",
													jobTitle: "",
													email: "",
													lists: [],
													topic: this.getIsAssessmentOffer() ? "offer" : null,
													brand: null,
													product: null,
													upc: "",
													lotCode: "",
													addr1: "",
													addr2: "",
													city: "",
													state: "",
													zip: "",
													yearlyUsage: "",
													biggestConcern: "",
													country: "",
													age: "",
													industry: "",
													numberOfEmployees: "",
													gender: "",
													company: "",
													message: "",
													phone: "",
													fax: "",
													region: null,
													group: "contactUs"
												}}
												validate={this.validate}
												onSubmit={this.onSubmit}>
												{(props) => (
													<form className={f.form} onSubmit={props.handleSubmit} noValidate>
														<RequiredNote />
														<ErrorSummary errors={summaryErrors(props)} submitCount={props.submitCount} />
														<FormStatus status={submitError ? "error" : null} />

														<div className={f.row}>
															<Select
																label="Topic"
																required
																placeholder="Select a topic"
																options={this.topics}
																{...bind(props, "topic")}
																onChange={e => this.onTopicChange(props, e)}
															/>
															{collectProductInfo && (
																<Select
																	label="Brand"
																	required
																	placeholder="Select a brand"
																	options={this.brands}
																	{...bind(props, "brand")}
																	onChange={e => this.onBrandChange(props, e)}
																/>
															)}
															{collectRegion && (
																<Select
																	label="Region"
																	required
																	placeholder="Select a region"
																	options={this.regions}
																	{...bind(props, "region")}
																	onChange={e => this.onRegionChange(props, e)}
																/>
															)}
														</div>

														{collectProductInfo && selectedBrand !== null && (
															<>
																<div className={f.row}>
																	<Select
																		label="Product"
																		required
																		placeholder="Select a product"
																		options={selectedBrand.products}
																		{...bind(props, "product")}
																		onChange={e => props.setFieldValue('product', e.target.value)}
																	/>
																	<TextInput
																		label="12 Digit UPC"
																		required
																		mask="upc"
																		inputMode="numeric"
																		placeholder="X-XXXXX-XXXXX-X"
																		{...bind(props, "upc")}
																	/>
																</div>
																<TextInput
																	label="Date/Lot Code"
																	help="Found on the bottom of aerosol cans and on back of trigger products"
																	{...bind(props, "lotCode")}
																/>
															</>
														)}

														<div className={f.row}>
															<TextInput label="First Name" required autoComplete="given-name" placeholder="John" {...bind(props, "firstName")} />
															<TextInput label="Last Name" required autoComplete="family-name" placeholder="Doe" {...bind(props, "lastName")} />
														</div>

														{isOffer ? (
															<>
																<div className={f.row}>
																	<TextInput label="Job Title" autoComplete="organization-title" {...bind(props, "jobTitle")} />
																	<TextInput label="Company" autoComplete="organization" {...bind(props, "company")} />
																</div>
																<div className={f.row}>
																	<TextInput label="Phone" type="tel" autoComplete="tel" help={INTL_PHONE_HELP} {...bind(props, "phone")} />
																	<TextInput label="Email" type="email" required autoComplete="email" placeholder="jdoe@email.com" {...bind(props, "email")} />
																</div>
																<div className={f.row}>
																	<TextInput label="Address" autoComplete="street-address" {...bind(props, "addr1")} />
																	<TextInput label="Zip Code" autoComplete="postal-code" {...bind(props, "zip")} />
																</div>
																<div className={f.row}>
																	<Select label="Industry" placeholder="Select An Industry" options={this.industries} {...bind(props, "industry")} />
																	<Select label="Number of Employees" options={this.numberOfEmployees} {...bind(props, "numberOfEmployees")} />
																</div>
																<div className={f.row}>
																	<TextInput label="Yearly Usage" {...bind(props, "yearlyUsage")} />
																	<TextInput label="Biggest Concern" {...bind(props, "biggestConcern")} />
																</div>
																<Textarea label="Other Comments" {...bind(props, "message")} />
															</>
														) : (
															<>
																<div className={f.row}>
																	<TextInput label="Email" type="email" required autoComplete="email" placeholder="jdoe@email.com" {...bind(props, "email")} />
																	<TextInput label="Phone Number" type="tel" required autoComplete="tel" help={INTL_PHONE_HELP} {...bind(props, "phone")} />
																</div>
																{allowSubmit && (
																	<Textarea label="Comment, Question or Request" required {...bind(props, "message")} />
																)}
																<Disclosure
																	id="contact-extra"
																	title="Additional information"
																	// Forced open while a field inside has an error, so the
																	// message (and the summary link's target) is visible
																	open={showExtra || !!fieldError(props, "fax")}
																	onToggle={this.handleClickExtraInfo}
																>
																	<div className={f.row}>
																		<TextInput label="Address" autoComplete="address-line1" {...bind(props, "addr1")} />
																		<TextInput label="APT/Suite #" autoComplete="address-line2" {...bind(props, "addr2")} />
																	</div>
																	<div className={f.row}>
																		<TextInput label="City" autoComplete="address-level2" {...bind(props, "city")} />
																		<TextInput label="State" autoComplete="address-level1" {...bind(props, "state")} />
																	</div>
																	<div className={f.row}>
																		<TextInput label="Zip" autoComplete="postal-code" {...bind(props, "zip")} />
																		<TextInput label="Country" autoComplete="country-name" {...bind(props, "country")} />
																	</div>
																	<div className={f.row}>
																		<TextInput label="Fax Number" type="tel" {...bind(props, "fax")} />
																		<TextInput label="Company Name" autoComplete="organization" {...bind(props, "company")} />
																	</div>
																	<div className={f.row}>
																		<Select label="Age Range" placeholder="Select an Age Range" options={this.ages} {...bind(props, "age")} />
																		<Select label="Gender" placeholder="Select a Gender" options={this.genders} {...bind(props, "gender")} />
																	</div>
																</Disclosure>
															</>
														)}

														{!allowSubmit && ['product-request', 'sponsorship', 'sticker'].indexOf(selectedTopic.value) > -1 && (
															<p className={f.sectionIntro}>
																WD-40 Company does not have a formal sponsorship program at this time and is not able to provide product or sticker donations. We wish both new WD-40® Brand fans and those who have been sponsored by WD-40 Company in the past best of luck in their endeavors.
															</p>
														)}
														{!allowSubmit && selectedTopic.value === 'charity' && (
															<p className={f.sectionIntro}>
																WD-40 Company sponsors and supports projects and programs that improve the quality of life in the communities we serve and where our employees live and work. Our areas of focus include education, health care, community development, and arts & culture. To learn more, please visit the <a href="/community">Community Involvement</a> page on our website. If you have questions or if you would like to submit an official request for assistance based on the guidelines listed, please send an email to <a href="mailto:communityinvolvement@WD40.com">communityinvolvement@WD40.com</a>. Thanks for reaching out.
															</p>
														)}

														{allowSubmit && (
															<>
																<Fieldset id="lists" legend="Sign me up for emails for:">
																	<Checkbox
																		name="checkBrand"
																		label={<>WD-40<sup>&reg;</sup> Brand Products</>}
																		checked={props.values.lists.indexOf(17512397) > -1}
																		onChange={e => this.toggleList(props, 17512397, e.target.checked)}
																	/>
																</Fieldset>
																<div className={f.actions}>
																	<SubmitButton busy={props.isSubmitting}>Submit</SubmitButton>
																</div>
															</>
														)}
													</form>
												)}
											</Formik>
										</>
								}
							</div>
								<div className={cn(styles.contactData, "col-sm-4")}>
									<div className={styles.data}>
										<div>
											<p>Phone:</p>
											<span>WD-40 Customer Relations</span>
											<span><a href="tel:18883247596">1.888.324.7596</a></span>
										</div>
										<div>
											<p>Mailing Address:</p>
											<span>WD-40 Customer Relations</span>
											<span>P.O. Box 308</span>
											<span>Budd Lake, NJ, 07828</span>
										</div>
										<div>
											<p>Investor Relations:</p>
											<span>Wendy Kelley</span>
											<span><a href="tel:18883247596">1.888.324.7596</a></span>
											<span>
												<a href='mailto:investorrelations@wd40.com'>investorrelations@wd40.com</a>
											</span>
										</div>

										<div className={styles.textExtraInfo}>
											* All customer inquiries should be directed to Customer Relations at the phone number or mailing address listed. Product inquiries sent to this email address will not receive a response.
										</div>
									</div>
								</div>
							</div>
					</div>
				</div>
			</NewLayout>
		);
	}
}
